import { FETCH_CREDIT, FETCH_CREDIT_SUCCESS, FETCH_CREDIT_ERROR, 
    TOGGLE_CREDIT, TOGGLE_ALL_CREDIT, CHANGE_PAYMENT_AMOUNT, CHANGE_ADHOC_PAYMENT } from '../action-types/credit';
  
  const initialState = {
    fetching: false,
    invoicesAndpaymentAmountsBeforeAdhoc: null,
    originalInvoices: [],
    credit: [],
    paymentAmounts: {},
    adhocPaymentEnabled: false,
    adhocPayment: 0,
    error: ''
  }
  
  export default (state = initialState, action) => {
    switch(action.type) {
      case FETCH_CREDIT:
        return { ...state, fetching: true};
      case FETCH_CREDIT_SUCCESS:
        let paymentAmounts = {};
        action.payload.forEach(credit => {
          paymentAmounts[credit.entryNo] = Math.abs(credit.netAmount);
        });
        return { ...state, fetching: false, credit: action.payload, originalInvoices: action.payload, 
          paymentAmounts, error: '', adhocPaymentEnabled: false, adhocPayment: 0, invoicesAndpaymentAmountsBeforeAdhoc: null };
      case FETCH_CREDIT_ERROR:
        return { ...state, fetching: false, credit: [], error: action.payload };
      case TOGGLE_CREDIT:
        return {...state, credit: state.credit.map(credit => {
          if (credit.entryNo === action.payload) {
            return {...credit, selected: !credit.selected}
          }
          return {...credit} 
        })};
      case TOGGLE_ALL_CREDIT:
        return {...state, credit: state.credit.map(credit => {
          return {...credit, selected: action.payload}
        })};
      case CHANGE_PAYMENT_AMOUNT:
        return {...state, paymentAmounts: {...state.paymentAmounts, [action.payload.entryNo]: (+action.payload.paymentAmount)}}
      case CHANGE_ADHOC_PAYMENT:
        let adhocPaymentEnabled = action.payload.adhocPaymentEnabled;
        let adhocPayment = +action.payload.adhocPayment;
        let credit = JSON.parse(JSON.stringify(state.originalInvoices));
        let newPaymentAmounts = {};
        let backup = {};
        if (adhocPaymentEnabled && !state.adhocPaymentEnabled) {
          backup = {invoicesAndpaymentAmountsBeforeAdhoc: {credit: JSON.stringify(state.credit), paymentAmounts: JSON.stringify(state.paymentAmounts)}}
        }
        if (adhocPaymentEnabled) {
          if (adhocPayment > 0) {
            let balance = adhocPayment;
            credit.forEach(credit => {
              if (balance > 0) {
                if (credit.netAmount > balance) {
                    credit.paymentAmount = balance;
                  newPaymentAmounts[credit.entryNo] = balance;
                  balance = 0;
                } else {
                    credit.paymentAmount = credit.netAmount;
                  newPaymentAmounts[credit.entryNo] = credit.netAmount;
                  balance = balance - credit.netAmount;
                }               
              }
            })
          }
          return {...state, adhocPaymentEnabled, adhocPayment, credit, 
            paymentAmounts: {...state.paymentAmounts, ...newPaymentAmounts},
            ...backup
          }
        }
        return {...state, adhocPaymentEnabled, adhocPayment,
            credit: JSON.parse(state.invoicesAndpaymentAmountsBeforeAdhoc.credit),
          paymentAmounts: JSON.parse(state.invoicesAndpaymentAmountsBeforeAdhoc.paymentAmounts)
        }
      default:
        return state
    }
  }
  


// WEBPACK FOOTER //
// ./src/reducers/credit.js